import { render, staticRenderFns } from "./JcdcCheckbox.vue?vue&type=template&id=25218462"
import script from "./JcdcCheckbox.vue?vue&type=script&lang=ts"
export * from "./JcdcCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./JcdcCheckbox.vue?vue&type=style&index=0&id=25218462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports